/* =============================================================
   arije — Page « L'histoire d'arije »  —  v2
   Moteur d'animation. Vanilla JS, aucune dépendance.
   ============================================================= */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function DESKTOP() { return window.matchMedia('(min-width: 990px)').matches; }
  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }

  function debounce(fn, ms) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  /* --------------------------------------------------------
     Boucle rAF partagée
     -------------------------------------------------------- */
  var tickers = [];
  var running = false;
  function loop() {
    for (var i = 0; i < tickers.length; i++) {
      try { tickers[i](); } catch (e) { /* noop */ }
    }
    if (tickers.length) requestAnimationFrame(loop); else running = false;
  }
  function addTicker(fn) {
    tickers.push(fn);
    if (!running) { running = true; requestAnimationFrame(loop); }
  }

  /* --------------------------------------------------------
     Observateur de reveals (partagé)
     -------------------------------------------------------- */
  var io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('is-in');
          io.unobserve(en.target);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 })
    : null;

  function initReveals(root) {
    var els = root.querySelectorAll('.ah-reveal, .ah-mask, .ah-split, .ah-lines, .ah-kicker--rule, .ah-q');
    if (REDUCED || !io) {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('is-in'); });
      return;
    }
    Array.prototype.forEach.call(els, function (el) {
      if (el.classList.contains('is-in')) return;
      io.observe(el);
    });
  }

  /* --------------------------------------------------------
     Découpe en mots (titres) — cascade
     -------------------------------------------------------- */
  function splitWords(root) {
    var els = root.querySelectorAll('.ah-split:not([data-ah-split])');
    Array.prototype.forEach.call(els, function (el) {
      el.setAttribute('data-ah-split', '');
      var frag = document.createElement('span');
      frag.innerHTML = el.innerHTML;
      var out = '';
      var idx = 0;
      (function walk(node) {
        Array.prototype.forEach.call(node.childNodes, function (n) {
          if (n.nodeType === 3) {
            n.nodeValue.split(/(\s+)/).forEach(function (w) {
              if (!w.trim()) { out += w; return; }
              out += '<span class="ah-split__w" style="--ah-wd:' + (idx * 55) + 'ms">' + w + '</span>';
              idx++;
            });
          } else if (n.nodeType === 1) {
            if (n.tagName === 'BR') { out += '<br>'; return; }
            var t = n.tagName.toLowerCase();
            out += '<' + t + '>'; walk(n); out += '</' + t + '>';
          }
        });
      })(frag);
      el.innerHTML = '<span class="ah-split__line">' + out + '</span>';
    });
  }

  /* --------------------------------------------------------
     Découpe en LIGNES réelles (citation) — chaque ligne
     monte depuis un masque. Recalculé au redimensionnement.
     -------------------------------------------------------- */
  function splitLines(root) {
    var els = root.querySelectorAll('.ah-lines');
    Array.prototype.forEach.call(els, function (el) {
      if (!el.hasAttribute('data-ah-src')) {
        el.setAttribute('data-ah-src', el.innerHTML);
      }
      build(el);
      if (!el.hasAttribute('data-ah-resize')) {
        el.setAttribute('data-ah-resize', '');
        window.addEventListener('resize', debounce(function () {
          var wasIn = el.classList.contains('is-in');
          build(el);
          if (wasIn) el.classList.add('is-in');
        }, 250));
      }
    });

    function build(el) {
      el.classList.remove('is-in');
      el.innerHTML = el.getAttribute('data-ah-src');

      // 1. envelopper chaque mot
      var words = [];
      (function wrap(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (n) {
          if (n.nodeType === 3) {
            var parts = n.nodeValue.split(/(\s+)/).filter(function (p) { return p !== ''; });
            var f = document.createDocumentFragment();
            parts.forEach(function (p) {
              if (!p.trim()) { f.appendChild(document.createTextNode(' ')); return; }
              var s = document.createElement('span');
              s.className = 'ah-w';
              s.textContent = p;
              words.push(s);
              f.appendChild(s);
            });
            n.parentNode.replaceChild(f, n);
          } else if (n.nodeType === 1) {
            wrap(n);
          }
        });
      })(el);

      if (!words.length) return;

      // 2. regrouper par ligne d'après la position verticale réelle
      var lines = [];
      var current = null;
      var lastTop = null;
      words.forEach(function (w) {
        var top = Math.round(w.offsetTop);
        if (lastTop === null || Math.abs(top - lastTop) > 4) {
          current = [];
          lines.push(current);
          lastTop = top;
        }
        current.push(w);
      });

      // 3. reconstruire en lignes masquées
      var html = '';
      lines.forEach(function (line, i) {
        var txt = line.map(function (w) { return w.outerHTML; }).join(' ');
        html += '<span class="ah-lines__line"><span class="ah-lines__inner" style="--ah-ld:' + (i * 110) + 'ms">' + txt + '</span></span>';
      });
      el.innerHTML = html;
    }
  }

  /* --------------------------------------------------------
     Chapitres — média collé qui suit la lecture
     -------------------------------------------------------- */
  function initChapters(root) {
    var blocks = root.querySelectorAll('[data-ah-chapters]:not([data-ah-ready])');
    Array.prototype.forEach.call(blocks, function (block) {
      block.setAttribute('data-ah-ready', '');
      var items = block.querySelectorAll('.ah-chap__item');
      var figs = block.querySelectorAll('.ah-chap__fig');
      var counter = block.querySelector('[data-ah-counter]');
      if (!items.length) return;

      function pad(n) { return n < 10 ? '0' + n : '' + n; }
      function setActive(i) {
        Array.prototype.forEach.call(figs, function (f, n) { f.classList.toggle('is-active', n === i); });
        if (counter) counter.textContent = pad(i + 1) + ' / ' + pad(items.length);
      }
      setActive(0);
      if (!('IntersectionObserver' in window)) return;

      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) setActive(parseInt(en.target.getAttribute('data-index'), 10) || 0);
        });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      Array.prototype.forEach.call(items, function (it) { obs.observe(it); });
    });
  }

  /* --------------------------------------------------------
     Frise horizontale pinnée
     -------------------------------------------------------- */
  function initTimeline(root) {
    var blocks = root.querySelectorAll('[data-ah-timeline]:not([data-ah-ready])');
    Array.prototype.forEach.call(blocks, function (block) {
      block.setAttribute('data-ah-ready', '');
      var track = block.querySelector('.ah-tl__track');
      var viewport = block.querySelector('.ah-tl__viewport');
      var rail = block.querySelector('.ah-tl__rail');
      var axis = block.querySelector('.ah-tl__axis span');
      var items = block.querySelectorAll('.ah-tl__item');
      if (!track || !rail || !viewport) return;

      var distance = 0;
      function measure() {
        if (!DESKTOP() || REDUCED) {
          track.style.height = ''; rail.style.transform = ''; distance = 0; return;
        }
        distance = Math.max(0, rail.scrollWidth - viewport.clientWidth);
        track.style.height = (window.innerHeight + distance) + 'px';
      }
      function render() {
        if (!distance) return;
        var rect = track.getBoundingClientRect();
        var total = track.offsetHeight - window.innerHeight;
        var p = clamp(-rect.top / (total || 1), 0, 1);
        rail.style.transform = 'translate3d(' + (-p * distance).toFixed(2) + 'px,0,0)';
        if (axis) axis.style.setProperty('--ah-progress', p.toFixed(4));
        var vw = window.innerWidth;
        Array.prototype.forEach.call(items, function (it) {
          var r = it.getBoundingClientRect();
          it.classList.toggle('is-near', r.left < vw * 0.9 && r.right > vw * 0.05);
        });
      }
      measure();
      addTicker(render);
      window.addEventListener('resize', debounce(measure, 200));
      window.addEventListener('load', measure);
    });
  }

  /* --------------------------------------------------------
     Parallaxe   [data-ah-parallax="0.15"]
     -------------------------------------------------------- */
  function initParallax(root) {
    if (REDUCED) return;
    var els = root.querySelectorAll('[data-ah-parallax]:not([data-ah-ready])');
    if (!els.length) return;
    var list = Array.prototype.slice.call(els);
    list.forEach(function (el) { el.setAttribute('data-ah-ready', ''); });

    addTicker(function () {
      var vh = window.innerHeight;
      var mobile = !DESKTOP();
      list.forEach(function (el) {
        if (mobile && el.hasAttribute('data-ah-parallax-desktop')) { el.style.transform = ''; return; }
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var speed = parseFloat(el.getAttribute('data-ah-parallax')) || 0.12;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (p * speed * 100).toFixed(2) + 'px,0)';
      });
    });
  }

  /* --------------------------------------------------------
     Compteurs chiffrés
     -------------------------------------------------------- */
  function initCounters(root) {
    var els = root.querySelectorAll('[data-ah-count]:not([data-ah-ready])');
    if (!els.length) return;

    Array.prototype.forEach.call(els, function (el) {
      el.setAttribute('data-ah-ready', '');
      var target = parseFloat(String(el.getAttribute('data-ah-count')).replace(',', '.')) || 0;
      var decimals = (String(el.getAttribute('data-ah-count')).split(/[.,]/)[1] || '').length;
      var sep = el.getAttribute('data-ah-sep') || ' ';

      function fmt(v) {
        var s = v.toFixed(decimals);
        var parts = s.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
        return parts.join(',');
      }

      if (REDUCED || !('IntersectionObserver' in window)) { el.textContent = fmt(target); return; }
      el.textContent = fmt(0);

      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          obs.unobserve(el);
          var start = null;
          var dur = 1800;
          (function step(ts) {
            if (start === null) start = ts;
            var p = clamp((ts - start) / dur, 0, 1);
            var eased = 1 - Math.pow(1 - p, 4);
            el.textContent = fmt(target * eased);
            if (p < 1) requestAnimationFrame(step);
          })(performance.now());
        });
      }, { threshold: 0.4 });
      obs.observe(el);
    });
  }

  /* --------------------------------------------------------
     Boot
     -------------------------------------------------------- */
  function init(root) {
    root = root || document;
    splitWords(root);
    splitLines(root);
    initChapters(root);
    initTimeline(root);
    initParallax(root);
    initCounters(root);
    initReveals(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  // Les polices peuvent changer la césure des lignes : on recalcule.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { splitLines(document); initReveals(document); });
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest ? e.target.closest('.ah-chap__item, .ah-tl__item, .ah-num__item') : null;
    if (item) item.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  window.ArijeHistoire = { init: init };
})();
